<template>
  <section :class="canEdit?'c_p':''" style="padding: 4px 4px 4px 0px;min-width: 20px;" v-if="!editFlag" @click="showInput()" @dblclick="showInput()">{{$commonJs.numFixed(changeValue)}}</section>
  <section v-else><input @input="changeValue=changeValue==0?0:changeValue.replace(/\D|^[0]+/g,'')" @keypress.enter="hideInput" class="sales_input" :id="randomId" type="text" v-model="changeValue" @focusout="hideInput()"/></section>
  <!--  changeValue.replace(/\D/g,'')  或  changeValue.replace(/\D|^[0]+/g,'')-->
</template>
<script>
export default {
  name: 'editTool',
  model: {
    prop: 'value',
    event: 'changeValue'
  },
  props: [
    'value',
    'canEdit'
  ],
  data () {
    return {
      changeValue: this.value,
      editFlag: false,
      randomId: 'selectId' + new Date().getTime() + Math.random() * 1000
    }
  },
  methods: {
    showInput () {
      setTimeout(() => {
        if (this.canEdit) {
          let inputList = document.querySelectorAll('.sales_input')
          if (inputList && inputList.length > 0) {
            return false
          }
          this.editFlag = true
          setTimeout(() => {
            document.getElementById(this.randomId).focus()
          }, 100)
        }
      }, 50)
    },
    hideInput () {
      if (this.changeValue === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误:',
          content: '填写数值不能为空',
          stayTime: 5
        })
        document.getElementById(this.randomId).focus()
        return false
      }
      this.$emit('changeValue', this.changeValue)
      this.editFlag = false
    }
  }
}
</script>
<style scoped>
  input{
    width: 90%;
    position: relative;
    font-size: 12px;
    border: 1px solid #C73343;
    border-radius: 4px;
    padding: 3px;
    margin-left: -4px;
    margin-top: -3px;
    outline: none;
  }
  section{
    position: relative;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/asmTd.vue